import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CodatCompanyRefreshRequestStatus } from './codat-company-refresh-request.status.enum';
import { CodatCompanyRefreshRequestType } from './codat-company-refresh-request.type.enum';

const CodatCompanyRefreshRequestSchema = WithBaseEntitySchema(
    z
        .object({
            codatCompany: z.string(),
            type: EnumSchema(CodatCompanyRefreshRequestType),
            status: EnumSchema(CodatCompanyRefreshRequestStatus),
            failureCode: z.string().optional(),
            failureMessage: z.string().optional(),
        })
        .strict(),
);

export class CodatCompanyRefreshRequest extends FromSchema(CodatCompanyRefreshRequestSchema) implements BaseEntity {
    id: string;
    codatCompany: string;
    type: CodatCompanyRefreshRequestType;
    status: CodatCompanyRefreshRequestStatus;
    failureCode?: string;
    failureMessage?: string;
    updatedAt: Date;
    createdAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
